// REACT_APP_VERSION plní CRA při buildu z package.json (přes $npm_package_version
// v .env), takže build musí běžet přes npm skript (npm run build), jinak je prázdná.
export const APP_VERSION = process.env.REACT_APP_VERSION || '';
